"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import _ from "lodash";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiGrid, {
  GridController
} from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
const _gridController = new GridController(
  new APIDataSource("api://base.auth/api/v1/web-resource-elements")
);
let WebPageRulesSettingDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.activeTab = "web-page-control";
    this.gridController = _gridController;
    this.webResourceItem = null;
    this.selectedDuplicate = "";
    this.selectedUploadData = "";
    this.selectedDownloadData = "";
    this.selectedPrint = "";
    this.selectedIds = [];
    this.selectedLock = false;
    this.choice_list = [
      { label: this.$t("add_rules.form.choice_list_1"), value: "ALLOW" },
      {
        label: this.$t("add_rules.form.choice_list_2"),
        value: "ALLOW_AND_RECORD"
      },
      {
        label: this.$t("add_rules.form.choice_list_3"),
        value: "RESTRICTION_AND_RECORD"
      }
    ];
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  open(item) {
    return __async(this, null, function* () {
      let duplicateData = _.find(item.accessRules, { code: "duplicate" });
      if (duplicateData !== void 0) {
        this.selectedDuplicate = duplicateData.power;
      }
      let fileUploadData = _.find(item.accessRules, { code: "file_upload" });
      if (fileUploadData !== void 0) {
        this.selectedUploadData = fileUploadData.power;
      }
      let fileDownloadData = _.find(item.accessRules, { code: "file_download" });
      if (fileDownloadData !== void 0) {
        this.selectedDownloadData = fileDownloadData.power;
      }
      let prindData = _.find(item.accessRules, { code: "print" });
      if (prindData !== void 0) {
        this.selectedPrint = prindData.power;
      }
      this.selectedIds = item.selectedElementIds;
      this.webResourceItem = item;
      this.dialog.visible = true;
    });
  }
  handleSelect(data) {
    return __async(this, null, function* () {
      if (this.activeTab === data) {
        return;
      }
      this.activeTab = data;
      if (this.activeTab === "web-page-control") {
        console.log(this.webResourceItem.accessRules);
        let duplicateData = _.find(this.webResourceItem.accessRules, {
          code: "duplicate"
        });
        if (duplicateData !== void 0) {
          this.selectedDuplicate = duplicateData.power;
        }
        let fileUploadData = _.find(this.webResourceItem.accessRules, {
          code: "file_upload"
        });
        if (fileUploadData !== void 0) {
          this.selectedUploadData = fileUploadData.power;
        }
        let fileDownloadData = _.find(this.webResourceItem.accessRules, {
          code: "file_download"
        });
        if (fileDownloadData !== void 0) {
          this.selectedDownloadData = fileDownloadData.power;
        }
        let prindData = _.find(this.webResourceItem.accessRules, {
          code: "print"
        });
        if (prindData !== void 0) {
          this.selectedPrint = prindData.power;
        }
      }
      if (this.activeTab === "web-element-control") {
        this.gridController.pagePosition = "dialog";
        this.gridController.size = false;
        this.gridController.query.filter = `webpageResourceId==${this.webResourceItem.id}`;
        yield this.gridController.search();
        this.$nextTick(function() {
          if (this.selectedIds.length > 0) {
            this.selectedLock = true;
            for (let id of this.selectedIds) {
              let item = _.find(this.gridController.result.datas, {
                id
              });
              if (item !== void 0) {
                this._uiGrid._tableBody.toggleRowSelection(item, true);
              }
            }
            this.selectedLock = false;
          }
        });
      }
    });
  }
  //检测当前列表选中的数据
  checkSelectedGrid() {
    for (let id of this.selectedIds) {
      let selectedData = _.find(this.gridController.result.datas, {
        id
      });
      this.selectedLock = true;
      if (selectedData !== void 0) {
        this._uiGrid._tableBody.toggleRowSelection(selectedData, true);
      }
      this.selectedLock = false;
    }
  }
  selectItems(items) {
    try {
      if (!this.selectedLock) {
        let ids = _.map(items, "id");
        let unSelectData = _.differenceWith(
          this.selectedIds,
          ids,
          _.isEqual
        );
        for (let item of items) {
          let data = _.find(this.selectedIds, (str) => str === item.id);
          if (data === void 0) {
            this.selectedIds.push(item.id);
          }
        }
        for (const item of unSelectData) {
          const data = _.findIndex(this.selectedIds, (str) => str === item);
          let searchresult = _.find(this.gridController.result.datas, {
            id: item
          });
          if (searchresult !== void 0 && data !== -1) {
            this.selectedIds.splice(data, 1);
          }
        }
      }
    } catch (error) {
      if (error.hasOwnProperty("response")) {
        this.$message.error(error.response.data.errors.datas[0].message);
      }
    }
  }
  changePrint() {
    console.log(this.selectedPrint);
    console.log(this.webResourceItem.accessRules);
    let prindData = _.find(this.webResourceItem.accessRules, { code: "print" });
    if (prindData !== void 0) {
      prindData.power = this.selectedPrint;
    }
  }
  changeDuplicate() {
    let duplicateData = _.find(this.webResourceItem.accessRules, {
      code: "duplicate"
    });
    if (duplicateData !== void 0) {
      duplicateData.power = this.selectedDuplicate;
    }
  }
  changeUpload() {
    let uploadData = _.find(this.webResourceItem.accessRules, {
      code: "file_upload"
    });
    if (uploadData !== void 0) {
      uploadData.power = this.selectedUploadData;
    }
  }
  changeDownload() {
    let downloadData = _.find(this.webResourceItem.accessRules, {
      code: "file_download"
    });
    if (downloadData !== void 0) {
      downloadData.power = this.selectedDownloadData;
    }
  }
  close() {
    this.gridController.query.current = 1;
    this.gridController.query.size = 10;
    this.activeTab = "web-page-control";
    this.dialog.visible = false;
  }
  confirm() {
    this.webResourceItem.selectedElementIds = this.selectedIds;
    this.$emit("submitRulesSettings", { item: this.webResourceItem });
    this.close();
  }
};
__decorateClass([
  Ref("uiGrid")
], WebPageRulesSettingDialog.prototype, "_uiGrid", 2);
WebPageRulesSettingDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      UiGrid
    }
  })
], WebPageRulesSettingDialog);
export {
  WebPageRulesSettingDialog as default
};
